import React, { useEffect, useState } from "react";
import { Button, Spin, message } from "antd";
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";
import { asyncGetLeasePreview } from "../../../../../store/easyApp/easyapp-async";

const PreviewStep: React.FC<PreviewStepProps> = ({ selectedAppGroup }) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { leasePreview } = useAppSelector((state) => state.easyapp);

  useEffect(() => {
    let objectUrl: string | null = null;

    const fetchPDF = async () => {
      if (!selectedAppGroup) return;

      if (leasePreview) {
        try {
          objectUrl = URL.createObjectURL(leasePreview);
          setPdfUrl(objectUrl);
          return;
        } catch (err) {}
      }

      setLoading(true);
      try {
        const res: any = await dispatch(asyncGetLeasePreview(selectedAppGroup));
        if (!res) {
          throw new Error("No PDF data received");
        }

        const blob = new Blob([res.payload], { type: "application/pdf" });
        objectUrl = URL.createObjectURL(blob);
        setPdfUrl(objectUrl);
      } catch (err) {
        message.error("Failed to load PDF preview");
      } finally {
        setLoading(false);
      }
    };

    fetchPDF();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [selectedAppGroup, leasePreview, dispatch]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 600,
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ height: 600 }}>
      {pdfUrl ? (
        <>
          <iframe src={pdfUrl} width="100%" height="100%" title="Lease Preview" />
          <Button
            type="primary"
            onClick={async () => {
              try {
                setLoading(true);
                const res: any = await dispatch(
                  asyncGetLeasePreview(selectedAppGroup)
                );
                if (!res) {
                  throw new Error("No PDF data received");
                }

                const blob = new Blob([res.payload], {
                  type: "application/pdf",
                });
                const objectUrl = URL.createObjectURL(blob);
                setPdfUrl(objectUrl);
              } catch (error) {
                console.log("Error refreshing PDF:", error);
                message.error("Failed to refresh PDF preview");
              } finally {
                setLoading(false);
              }
            }}
            loading={loading}
            disabled={loading}
          >
            Regenerate
          </Button>
        </>
      ) : (
        <p>No PDF available</p>
      )}
    </div>
  );
};

export default PreviewStep;
